import { fetchAssociativeLanguages } from 'legacy/lut/hoc/referenceLoader/fetchAssociativeLanguages'
import { fetchSalutations } from 'legacy/lut/hoc/referenceLoader/fetchSalutation'
import { lookupGetStateOld, setNextLookupState } from 'legacy/lut/store'
import { IReferenceCollection } from 'legacy/lut/store/state'
import { ReactNode, useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { selectUser } from 'core-components/sitebuilder/store/selectors/selectUser'
import { useGetReferenceCountriesQuery } from 'core/store/service/referenceCountries'
import { useGetReferenceCountriesCodeQuery } from 'core/store/service/referenceCountriesCode'
import { useGetReferenceLanguagesQuery } from 'core/store/service/referenceLanguages'
import { useGetReferenceLocalesQuery } from 'core/store/service/referenceLocales'
import { useGetReferenceOrganizationsQuery } from 'core/store/service/referenceOrganizations'

interface IReferenceLoader {
  children: ReactNode
}

export const ReferenceLoader = ({ children }: IReferenceLoader) => {
  const user = useSelector(selectUser)
  const { data: countries } = useGetReferenceCountriesQuery()
  const { data: countriesCode } = useGetReferenceCountriesCodeQuery()
  const { data: languages } = useGetReferenceLanguagesQuery()
  const { data: locales } = useGetReferenceLocalesQuery()
  const { data: organizations } = useGetReferenceOrganizationsQuery()

  const updateReference = useCallback((field: keyof IReferenceCollection, value: unknown) => {
    if (value) {
      const lookupOldState = lookupGetStateOld()
      setNextLookupState({
        ...lookupGetStateOld(),
        references: {
          ...lookupOldState.references,
          [field]: value,
        },
      })
    }
  }, [])

  useEffect(() => {
    updateReference('organizations', organizations)
  }, [organizations])

  useEffect(() => {
    updateReference('locales', locales)
  }, [locales])

  useEffect(() => {
    updateReference('languages', languages)
  }, [languages])

  useEffect(() => {
    updateReference('countries', countries)
  }, [countries])

  useEffect(() => {
    updateReference('countriesCode', countriesCode)
  }, [countriesCode])

  useEffect(() => {
    if (user.id) {
      fetchSalutations().then((data) => updateReference('salutations', data))
      fetchAssociativeLanguages().then((data) => updateReference('associativeLanguages', data))
    }
  }, [user.id])

  return <>{children}</>
}
